import { GET_NAV } from './action-types';
import { getRequestStatus } from '../requests/selectors';

export const nav = (state) => state.header.nav;
export const navExpiryTime = (state) => state.header.navExpiryTime;
export const [isFetching, hasError, errorData] = getRequestStatus(GET_NAV);
export const navLoaded = (state) => {
    return typeof navExpiryTime(state) === 'number' && navExpiryTime(state) > Date.now();
};
